var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.$route.name != 'Login' && this.$route.name != 'PasswordLost' && this.$route.name != 'Passwordreset' )?_c('HeaderApp'):_vm._e(),_c('div',{attrs:{"id":"content"}},[_c('router-view')],1),_c('FooterApp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }